import { getStrapiBaseUrl, getWithLocaleFallback } from "../../services/strapiApi";

// Fonction pour récupérer les données de la page Contact
export const getContactPageData = async (locale) => {
  return getWithLocaleFallback(
    "/contact-page?populate[heroComponent][populate][0]=image&populate[contactInfo]=*&populate[contactStats]=*&populate[partnerSection]=*",
    { locale, fallbackLocale: 'fr' }
  );
};

// Fonction pour formater les donnÃ©es de la page Contact
export const formatContactPageData = (strapiData) => {
  if (!strapiData) {
    return {
      id: null,
      title: "",
      heroComponent: {
        title: "",
        description: "",
        image: "",
      },
      contactInfo: [],
      contactStats: [],
      partnerSection: {
        title: "",
        description: "",
      },
    };
  }

  // Handle both cases: strapiData with attributes or strapiData as attributes directly
  const attributes = strapiData.attributes || strapiData;

  // Extract image URL with multiple fallback strategies
  let heroImageUrl = "";
  if (attributes.heroComponent?.image?.data?.attributes?.url) {
    const imageUrl = attributes.heroComponent.image.data.attributes.url;
    heroImageUrl = imageUrl.startsWith("http")
      ? imageUrl
      : `${getStrapiBaseUrl()}${imageUrl}`;
  } else if (attributes.heroComponent?.image?.data?.url) {
    const imageUrl = attributes.heroComponent.image.data.url;
    heroImageUrl = imageUrl.startsWith("http")
      ? imageUrl
      : `${getStrapiBaseUrl()}${imageUrl}`;
  } else if (attributes.heroComponent?.image?.url) {
    const imageUrl = attributes.heroComponent.image.url;
    heroImageUrl = imageUrl.startsWith("http")
      ? imageUrl
      : `${getStrapiBaseUrl()}${imageUrl}`;
  }

  // Format contact info
  const contactInfo =
    attributes.contactInfo?.map((info) => ({
      id: info?.id,
      icon: info?.icon || "",
      title: info?.title || "",
      content: info?.content || "",
      description: info?.description || "",
    })) || [];

  // Format contact stats
  const contactStats =
    attributes.contactStats?.map((stat) => ({
      id: stat?.id,
      value: stat?.value || "",
      label: stat?.label || "",
    })) || [];

  return {
    id: strapiData.id,
    title: attributes.Title || "",
    heroComponent: {
      title: attributes.heroComponent?.title || "",
      description: attributes.heroComponent?.description || "",
      image: heroImageUrl,
    },
    contactInfo,
    contactStats,
    location: attributes.location || null,
    partnerSection: {
      title: attributes.partnerSection?.title || "",
      description: attributes.partnerSection?.description || "",
    },
  };
};
